//
// Surfaced exceptions — the block that tells a manager what needs them.
//
// It renders NOTHING when there is nothing wrong: no header, no placeholder,
// no "all clear" card. That total absence is the point. A screen that pads
// itself on a quiet day is the padding the redesign removed (spec §6).
import React from 'react';
import { GlassCard } from '../LiquidGlass';
import { useLanguage } from '../../../context/LanguageContext';
import { ensureKitCss } from './kitCss';

export function AttentionList({ items, title }) {
    ensureKitCss();
    const { t } = useLanguage();

    if (!Array.isArray(items) || items.length === 0) return null;

    return (
        <div data-testid="attention-list">
            <div className="pk-section-label">
                {title || t('needs_attention', {}, 'Needs Attention')}
            </div>
            <div className="pk-att-list">
                {items.map((item, i) => {
                    const tappable = typeof item.onPress === 'function';
                    return (
                        <GlassCard
                            key={item.id != null ? item.id : i}
                            as={tappable ? 'button' : 'div'}
                            lift={tappable}
                            type={tappable ? 'button' : undefined}
                            onClick={tappable ? item.onPress : undefined}
                            className={`pk-att-row${tappable ? ' pk-att-tappable' : ''}`}
                        >
                            <span
                                className={`pk-att-dot pk-att-dot-${item.tone || 'muted'}`}
                                aria-hidden="true"
                            />
                            <span className="pk-att-text">{item.text}</span>
                            {item.chip && (
                                <span className={`pk-pill pk-pill-${item.chip.tone || 'muted'}`}>
                                    {item.chip.label}
                                </span>
                            )}
                        </GlassCard>
                    );
                })}
            </div>
        </div>
    );
}

export default AttentionList;
